import styled from '@emotion/styled';
import { BaseButton, Variables } from '../../base';

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SectionLabel = styled.div`
    font-size: 11px;
    font-weight: ${Variables.FontWeight.semibold};
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMild};
`;

export const Card = styled.div`
    border: 1px solid ${Variables.ThemeLight.Border2};
    border-radius: 8px;
    background: ${Variables.ThemeLight.Background3};
    overflow: hidden;
`;

export const CardHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    border-bottom: 1px solid ${Variables.ThemeLight.Border2};
`;

export const PatientName = styled.span`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.ThemeLight.TextStrong};
`;

export const PatientMeta = styled.span`
    font-size: 12px;
    color: ${Variables.ThemeLight.TextMild};
`;

export const MultiBadge = styled.span`
    margin-left: auto;
    font-size: 11px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.ThemeLight.TextMedium};
    background: ${Variables.ThemeLight.NeutralMild1};
    border: 1px solid ${Variables.ThemeLight.Border2};
    border-radius: 4px;
    padding: 3px 6px 2px;
    white-space: nowrap;
`;

export const OpenLink = styled(BaseButton)`
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-width: unset;
    height: auto;
    font-size: 13px;
    font-weight: ${Variables.FontWeight.medium};
    color: ${Variables.ThemeLight.PrimaryConstant6};
    background: transparent;
    background-color: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
        background: transparent;
        background-color: transparent;
    }
`;

export const MetricsRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
`;

export const MetricCell = styled.div<{ $borderLeft?: boolean }>`
    padding: 9px 14px;
    border-left: ${props => (props.$borderLeft ? `1px solid ${Variables.ThemeLight.Border2}` : 'none')};
    min-width: 0;
`;

export const MetricLabel = styled.div`
    font-size: 11px;
    font-weight: ${Variables.FontWeight.medium};
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMild};
    margin-bottom: 3px;
`;

export const MetricValue = styled.div`
    font-size: 13px;
    font-weight: ${Variables.FontWeight.medium};
    color: ${Variables.ThemeLight.TextStrong};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ClaimRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border-bottom: 1px solid ${Variables.ThemeLight.Border2};
`;

export const ClaimRowField = styled.div<{ $flex?: string }>`
    flex: ${props => props.$flex || '1'};
    min-width: 0;
`;

export const ClaimIdValue = styled.div`
    font-size: 12px;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    color: ${Variables.ThemeLight.TextMedium};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Footer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 14px;
    background: ${Variables.ThemeLight.NeutralMild1};
`;

export const FooterMeta = styled.span`
    font-size: 12px;
    color: ${Variables.ThemeLight.TextMild};
`;

export const FooterTotal = styled.span`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.semibold};
    color: ${Variables.ThemeLight.TextStrong};
`;

export const EmptyState = styled.div`
    font-size: 13px;
    color: ${Variables.ThemeLight.TextMild};
    padding: 12px 0;
`;

export const LoadingState = styled.div`
    font-size: 13px;
    color: ${Variables.ThemeLight.TextMild};
    font-style: italic;
    padding: 12px 0;
`;

export const RowOpenButton = styled(BaseButton)`
    flex: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: unset;
    height: auto;
    color: ${Variables.ThemeLight.PrimaryConstant6};
    background: transparent;
    background-color: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
    cursor: pointer;

    &:hover {
        background: transparent;
        background-color: transparent;
    }
`;
